import React, { useState } from 'react';
import { Box, Button } from '@mui/material';

import { useStyles } from './styles';
import MapContentItem from './MapContentItem';
import { IMapFloor } from '@interfaces/map';

const MapContent = ({ maps }: { maps: IMapFloor[] }) => {
  const classes = useStyles();

  const [active, setActive] = useState<IMapFloor | null>(maps[0] || null);

  return (
    <Box sx={classes.root}>
      <Box sx={classes.actions}>
        {maps.map((floor) => (
          <Button
            key={floor.id}
            sx={classes.button(floor.id === active?.id)}
            onClick={() => setActive(floor)}
          >
            {floor.name}
          </Button>
        ))}
      </Box>

      <Box sx={classes.imageBox}>
        {active?.image?.url ? <MapContentItem url={active.image.url} /> : null}
      </Box>
    </Box>
  );
};

export default MapContent;
